var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F1F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 16C27.0938 16 28 16.9062 28 18V28C28 29.125 27.0938 30 26 30H18C16.875 30 16 29.125 16 28V18C16 16.9062 16.875 16 18 16H19.25H19.5312C19.7812 14.875 20.7812 14 22 14C23.1875 14 24.2188 14.875 24.4375 16H24.75H26ZM18.5 17.5H18C17.7188 17.5 17.5 17.75 17.5 18V28C17.5 28.2812 17.7188 28.5 18 28.5H26C26.25 28.5 26.5 28.2812 26.5 28V18C26.5 17.75 26.25 17.5 26 17.5H25.5V18.25C25.5 18.6875 25.1562 19 24.75 19H22H19.25C18.8125 19 18.5 18.6875 18.5 18.25V17.5ZM21.25 16.5C21.25 16.9375 21.5625 17.25 22 17.25C22.4062 17.25 22.75 16.9375 22.75 16.5C22.75 16.0938 22.4062 15.75 22 15.75C21.5625 15.75 21.25 16.0938 21.25 16.5ZM25.0312 22.375L21.6875 25.7188C21.5312 25.8438 21.3438 25.9375 21.1562 25.9375C20.9688 25.9375 20.75 25.8438 20.625 25.7188L18.9688 24.0312C18.6562 23.75 18.6562 23.2812 18.9688 22.9688C19.25 22.6875 19.7188 22.6875 20.0312 22.9688L21.1562 24.125L23.9688 21.3125C24.25 21.0312 24.7188 21.0312 25.0312 21.3125C25.3125 21.5938 25.3125 22.0938 25.0312 22.375Z",
    fill: "#00A6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.7a0f41803cbf1775856e6ad9604e3ff5.svg";
export { ForwardRef as ReactComponent };